var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7CantosDecor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 929.7 219.9",
    width: 929.7,
    height: 219.9,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.3,47.3h-45v21.3l-1.4,2.2-20,30.5v71h66.4c47.1,0,77.3-23.6,77.3-62.5s-30.2-62.5-77.3-62.5ZM370.2,148h-35.7v-76.4h35.7c30,0,50.3,12.5,50.3,38.2s-20.3,38.2-50.3,38.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.6,155.1c17,0,27.7-4.5,37.9-12.7l14.8,16.2c-13.7,12.1-31.4,17.5-54.1,17.5-40.5,0-63.9-20.4-63.9-53s23.2-53.2,62-53.2,59.6,18.2,59.6,53-.2,4.8-.7,6.4h-94.3c2.5,17.7,15.9,25.7,38.7,25.7ZM482.1,111.7l67.3-.4c-4.3-14.1-15.5-20.4-33-20.4s-30.4,6.8-34.3,20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.8,176.2c-38.6,0-62.3-20.5-62.3-53s23.7-53.2,62.3-53.2,46.6,12.1,54.8,27.1l-25.5,10c-5.7-10.9-16.6-14.8-29.1-14.8-20.5,0-35.7,10.2-35.7,30.9s15.2,30.7,35.7,30.7,23.8-4.1,29.8-15.4l25.4,10.2c-8.2,15.4-27,27.5-55.4,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.2,123.2c0-32.9,23.9-53,62.9-53s62.9,20.2,62.9,53-24.1,53-62.9,53-62.9-20.4-62.9-53ZM794.3,123.2c0-20.5-15.4-30.5-36.2-30.5s-36.1,10-36.1,30.5,15.4,30.5,36.1,30.5,36.2-10.2,36.2-30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M831.1,172.3v-98.4h27.7v20.4c8-14.8,25-22.5,43.9-22.5v23.7c-21.4,0-38,8.4-43.9,25.7v51.1h-27.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "318.7 47.3 318.7 66 305.9 85.5 248.9 172.3 216.2 172.3 283.9 71.2 189.2 71.2 189.2 47.3 318.7 47.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.4,177.2h-84.3c-6.9,0-12.5-5.6-12.5-12.5v-84.3c0-6.9,5.6-12.5,12.5-12.5h84.3c6.9,0,12.5,5.6,12.5,12.5v84.3c0,6.9-5.6,12.5-12.5,12.5ZM76.2,77.5c-1.7,0-3,1.4-3,3v84.3c0,1.7,1.4,3,3,3h84.3c1.7,0,3-1.4,3-3v-84.3c0-1.7-1.4-3-3-3h-84.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 28.1,
    y: 40.8,
    width: 99.7,
    height: 99.7,
    rx: 13.3,
    ry: 13.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7CantosDecor);
export default __webpack_public_path__ + "static/media/7Cantos_Decor.19f5390661aafb5ae3b281641d551af8.svg";
export { ForwardRef as ReactComponent };